import AttendanceSerializer from './base';

export default class SickbayVisit extends AttendanceSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      notes: '',
      releaseNotes: '',
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
